import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'app-view-tour-success',
  templateUrl: './view-tour-success.component.html',
  styleUrls: ['./view-tour-success.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ViewTourSuccessComponent implements OnInit {

  @Input()
  inline: boolean;

  constructor() { }

  ngOnInit() {
  }

}
